import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import debounce from 'lodash/debounce';
import { getConvertedText, getIsChatTyping } from '../../../../redux/chat/selectors';
import { chatActions } from '../../../../redux/chat/actions';

export const useMessageInput = (
  setValue,
  value,
  handleSendMessage,
  chatId,
) => {
  const dispatch = useDispatch();
  const convertedText = useSelector(getConvertedText);
  const isTyping = useSelector(getIsChatTyping);

  const checkTokens = useCallback(
    debounce((text) => {
      dispatch(chatActions.checkTokens({ id: chatId, additional_text: text }));
    }, 600),
    [dispatch, chatId],
  );

  const handleChange = (e) => {
    setValue(e.target.value);
    checkTokens(e.target.value);
  };

  useEffect(() => {
    if (convertedText) {
      setValue(convertedText);
      checkTokens(convertedText);
    }
  }, [convertedText, checkTokens]);

  const handleKeyPress = (e) => {
    if (e.shiftKey && e.key === 'Enter') {
      setValue(prev => `${prev}`);
      return;
    }
    if (e.key === 'Enter') {
      e.preventDefault();
      if (value.trim().length && !isTyping) {
        handleSendMessage(value);
        setValue('');
      }
    }
  };

  return {
    handleKeyPress,
    handleChange,
  };
};
